<div class="availability-modal" [ngClass]="{'small-width': participatingRestaurants}">
    <div class="availability-section">
        @defer {
            <finder-ra-single-select #restaurantsSelect
                *ngIf="participatingRestaurants"
                [label]="data?.selectRestaurantsLabel"
                [options]="restaurantOptions"
                (itemSelected)="selectRestaurantAction($event)"
                [value]="selectedRestaurantOption"
                [disabled]="participatingRestaurants.length === 1">
            </finder-ra-single-select>
        }
        <finder-loading-spinner class="loading" *ngIf="!maxCalendarDays">
        </finder-loading-spinner>
        <finder-date-picker-wrapper
            *ngIf="maxCalendarDays"
            [maxDays]="maxCalendarDays"
            [(date)]="mealPeriodScheduleService.date"
            [highlightedDates]="resortReservationDates"
            (dateChanged)="onDateChanged($event)"
            (datePickerClose)="onCalendarClose($event)">
                <label class="label">{{data?.dateLabel}}</label>
                <finder-input class="date-input" type="text" [value]="mealPeriodScheduleService.fullFormatDate" readonly="readonly"></finder-input>
        </finder-date-picker-wrapper>
        <div class="meal-periods-mobile"
            *ngIf="!participatingRestaurants"
            [ngClass]="{loading: mealPeriodScheduleService.isLoading}">
            <finder-loading-spinner *ngIf="mealPeriodScheduleService.isLoading; else mealPeriods"></finder-loading-spinner>
        </div>
        @defer {
            <finder-ra-single-select
                [label]="data?.selectTimeLabel"
                [options]="timesOptions"
                [value]="selectedTime"
                (itemSelected)="onSelectTime($event)">
            </finder-ra-single-select>
        }
        <div class="party-size">
            <label for="partySizeCounter">{{ data?.partySizeLabel }}</label>
            @defer {
                <finder-ra-counter
                    [lowerLimit]="partySizeLowerLimit"
                    [upperLimit]="partySizeUpperLimit"
                    [minusAlt]="data?.partySizeMinusAltText"
                    [pplusAlt]="data?.partySizePlusAltText"
                    [counterAlt]="data?.partySizeAltText"
                    [value]="partySizeCountDefaultValue"
                    (updated)="onCounterChanged($event)"
                ></finder-ra-counter>
            }
        </div>
        <div *ngIf="selectedTimeObject && selectedTimeObject.specialNeeds" class="accessible-options">
            <div class="checkbox" *ngFor="let specialNeed of selectedTimeObject.specialNeeds">
                @defer {
                    <finder-ra-checkbox
                        [id]="specialNeed.id"
                        [checked]="specialNeed.checked"
                        [disabled]="(specialNeed.disabled) ? '' : null"
                        (checkedChanged)="onSelectSpecialNeed($event, specialNeed)">
                        {{specialNeed.name}}
                    </finder-ra-checkbox>
                }
                <span *ngIf="specialNeed.disclaimer" class="disclaimer">{{specialNeed.disclaimer}}</span>
            </div>
        </div>
        <finder-button
            [disabled]="!selectedTime || !maxCalendarDays"
            id="search-time-button"
            [analyticsTracking]="false"
            [fullWidth]="true"
            (click)="searchAvailability()"
            theme="primary">
                {{data?.searchTimesButtonLabel}}
        </finder-button>
    </div>
    <div id="meal-periods-section"
        *ngIf="!participatingRestaurants"
        [ngClass]="{loading: mealPeriodScheduleService.isLoading}">
        <finder-loading-spinner *ngIf="mealPeriodScheduleService.isLoading; else mealPeriods"></finder-loading-spinner>
    </div>
    <div id="disclaimer-section">
        <div>{{ disclaimerText }}</div>
        <span class="no-schedule" *ngIf="!selectedTime">{{ noSchedulesDisclaimerText }}</span>
    </div>
    <div class="availability" [ngClass]="{loading: availabilityLoading}">
        <finder-loading-spinner *ngIf="availabilityLoading"></finder-loading-spinner>
        <ng-container *ngIf="!availabilityLoading && availabilityData?.offers">
            <hr/>
            <h3 class="reserve-title">{{ data.reserveAt }}</h3>
            <div *ngIf="availabilityData.offers" class="times">
                <finder-button *ngFor="let offer of availabilityData.offers"
                    theme="secondary"
                    [fitText]="true"
                    (click)="reserveTime(offer)">
                        {{ offer.time | FormatTime }}
                </finder-button>
            </div>
            <finder-loading-spinner class="conflict-loading" *ngIf="conflictCheckingInProgress"></finder-loading-spinner>
            <div *ngIf="conflict" class="conflict">
                <div id="conflict-message">
                    <div class="message" role="alert">
                        <finder-font-icon name="alert" size="s"></finder-font-icon>
                        <span>{{ conflict.message }}</span>
                    </div>
                    <div class="restaurant-name">
                        <finder-font-icon name="dining" size="s"></finder-font-icon>
                        <h3>{{ conflict.restaurantName }}</h3>
                    </div>
                    <div class="description">
                        {{ conflictTime }}
                        <span class="meal-period">{{ conflict.mealPeriod }} {{ conflict.forText }} {{ conflict.totalParty }}</span>
                    </div>
                </div>
                <div class="conflict-disclaimer">
                    <span class="disclaimer-text">{{ conflict.disclaimer }}</span>
                    <finder-button
                        [disabled]="!replaceReservationUrl"
                        href="{{replaceReservationUrl}}"
                        class="action-btn"
                        [fullWidth]="true"
                        theme="primary">
                        {{conflict.buttonLabel}}
                    </finder-button>
                </div>
            </div>
            <div
                *ngIf="errorMessage"
                class="error-message"
                [innerHTML]="mealPeriodScheduleService.mealPeriodsData.labels?.defaultErrorMessage | safeHtml"
                >
            </div>
        </ng-container>
        <div *ngIf="!availabilityLoading && availabilityData?.unavailableReason" class="times-unavailable">
            <hr/>
            <div class="head">{{ availabilityData.unavailableMessage.head }}</div>
            <div class="title">{{ unavailableMessageTitle }}</div>
            <div class="subtitle">{{ availabilityData.unavailableMessage.subtitle }}</div>
            <finder-breadcrumb
                class="link-text"
                [breadcrumb]="availabilityData.unavailableMessage.linkTemplate"
                [links]="availabilityData.unavailableMessage.links">
            </finder-breadcrumb>
        </div>
        <div *ngIf="!availabilityLoading && !!defaultAvailabilityError" class="times-unavailable">
            <hr/>
            <span [innerHTML]="defaultAvailabilityError | safeHtml"></span>
        </div>
    </div>
</div>
<ng-template #mealPeriods>
    <finder-meal-period
        *ngIf="mealPeriodSchedules"
        [mealPeriodsOrder]="mealPeriodsOrder"
        [mealPeriods]="mealPeriodScheduleService.mealPeriodsData.mealPeriods"
        [schedules]="mealPeriodSchedules"
        [labels]="mealPeriodScheduleService.mealPeriodsData.labels">
    </finder-meal-period>
    <div *ngIf="!mealPeriodSchedules">
        {{mealPeriodScheduleService.mealPeriodsData.labels?.noSchedules}}
    </div>
</ng-template>
